import ICU from 'i18next-icu';
import type { InitOptions } from 'i18next';
import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import { Text } from '@wix/cli-ui-kit';

export function createI18n(messages: Record<string, string>) {
  const config: InitOptions = {
    lng: 'en',
    resources: { en: { translation: messages } },
    keySeparator: false,
    react: {
      // @ts-expect-error - missing type
      defaultTransParent: Text,
    },
  };

  const icu = new ICU();
  const i18nInstance = i18next.createInstance(config);
  i18nInstance.use(icu);
  i18nInstance.use(initReactI18next);

  void i18nInstance.init();

  return i18nInstance;
}
